<template>
  <b-container>
    <!-- 状态切换-->
    <div class="wait-status">
      <span :class="stateTYype == 1 ? '' : 'status-back'" @click="switchStateTap('next')"
        >未开始</span
      >
      <span :class="stateTYype == 2 ? '' : 'status-back'" @click="switchStateTap('done')"
        >历史课程</span
      >
      <div class="wait-heng">
        <b-icon
          icon="caret-up-fill"
          :class="stateTYype == 'next' ? 'caret-up-fill ' : 'caret-up-fill status-write'"
        ></b-icon>
        <b-icon
          icon="caret-up-fill"
          :class="stateTYype == 'done' ? 'caret-up-fill ' : 'caret-up-fill status-write'"
        ></b-icon>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content-live" v-if="liveAll.length > 0">
      <div
        class="list"
        v-for="(list, index) in liveAll"
        :key="index"
        @click="openLiveAndVideo(list)"
      >
        <div class="list-top">
          <div>
            <img src="../../../images/list-time.png" alt="" />
            <span>{{
              list.class_time ? list.class_time + " 开课" : "暂未设置开课时间"
            }}</span>
          </div>
          <div :class="list.classroom.type == 2 ? 'overseas-study' : 'ielts'">
            {{ list.classroom.type_name }}
          </div>
        </div>
        <div class="list-content">
          <div class="lc-left"><img :src="list.cover" alt="" /></div>
          <div class="lc-right">
            <div class="lc-title">{{ list.title }}</div>
            <div>
              <div class="lc-teacher">授课老师 {{ list.teacher_name }}</div>
              <div class="lc-time" v-if="timeState[index].states == 2">
                <span :class="list.status == 2 ? 'time-start' : ''"
                  >{{ list.status == 2 ? "已开始" : "倒计时" }}:</span
                >
                <span class="time-start">{{ timeState[index].time }}</span>
              </div>
              <div
                class="lc-time"
                v-if="timeState[index].states == 3 || timeState[index].states == 1"
              >
                {{ timeState[index].time }}
              </div>
              <div class="lc-time" v-if="timeState[index].states == 4">
                上课时间:暂未设置
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-if="allPage != 0"
      :show-jumper="true"
      :total="total"
      :currentPage="requestData.page"
      :pagerCount="requestData.paginate"
      @prev-click="prevClick"
      @next-click="nextClick"
      @prev-quick-click="prevQuickClick"
      @next-quick-click="nextQuickClick"
      @current-change="currentChange"
    />
    <!--  缺省页-->
    <div class="no-list" v-if="liveAll.length <= 0">
      <img src="../../../images/default-graph.png" alt="" />
      {{ stateTYype == "next" ? "还没有课程，去买一个吧~" : "暂无历史课程" }}
    </div>
    <audioplayback :show="showVideo" :title="videoTitle" ref="audioPlayback">
      <div class="liveView">
        <video-player
          class="vjs-custom-skin"
          ref="videoPlayer"
          :options="playerOptions"
          @ready="onPlayerReadied"
          @timeupdate="onTimeupdate"
          :playsinline="playsinline"
        ></video-player>
      </div>
    </audioplayback>
    <tips :isShow="remindShow" @close="closeShow" @determine="join"></tips>
  </b-container>
</template>

<script>
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import "@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { web_show, rtm_token_web } from "@/api/mycenter.js";
import pagination from "./paging.vue";
import audioplayback from "./audio_playback.vue";
import tips from "./live_tip.vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "videojs-contrib-hls";
export default {
  components: {
    VueClockPicker,
    DatePicker,
    pagination,
    videoPlayer,
    audioplayback,
    tips,
  },
  name: "LiveList",
  data() {
    return {
      remindShow: false, // 提醒弹窗
      stateTYype: "next", // next完成,done未完成
      liveAll: "", // 直播课合集
      nowTime: "", // 当前时间
      showVideo: false, // 视频展示
      videoTitle: "", // 视频标题
      timeState: [
        { states: "", time: "" },
        { states: "", time: "" },
        { states: "", time: "" },
        { states: "", time: "" },
        { states: "", time: "" },
        { states: "", time: "" },
      ], // 时间状态
      requestData: {
        type: "next",
        page: 1,
        paginate: 6,
      },
      total: 0, // 总页数
      allPage: 0, // 总条数
      /* */
      initialized: false,
      currentTech: "",
      streams: {
        rtmp: "",
        hls: "",
      },
      playerOptions: {
        overNative: true,
        autoplay: false,
        controls: true,
        techOrder: ["html5"],
        sourceOrder: true,
        aspectRatio: "16:9",
        flash: {
          hls: { withCredentials: false },
        },
        html5: { hls: { withCredentials: false } },
        sources: [
          {
            withCredentials: false,
            type: "application/x-mpegURL",
            src: "",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
      },
      joinLiving: {},
      /* */
    };
  },
  created() {
    console.log(this.timeState);
    this.liveList();
    this.nowTime = Date.parse(new Date());
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    currentStream() {
      return this.currentTech === "Flash" ? "RTMP" : "HLS";
    },
    playsinline() {
      let ua = navigator.userAgent.toLocaleLowerCase();
      // x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        // ios端
        return true;
      }
    },
  },
  methods: {
    join() {
      console.log('useruuid',this.$store.state.live_id)
      this.remindShow = false;
      rtm_token_web(this.joinLiving)
        .then((response) => {
          //  return false
          window.open(
            'https://ielts.honeybee-edu.com/dist/living.html?' +
              "rtmToken=" +
              encodeURIComponent(response.data) +
              "&userUuid=" +
              this.$store.state.live_id +
              "&userName=" +
              this.$store.state.name +
              "&roomUuid=" +
              this.joinLiving.roomUuid +
              "&roomName=" +
              this.joinLiving.roomName +
              "&duration=" +
              this.joinLiving.duration +
              "&roleType=" +
              2,
            "_blank"
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeShow(e) {
      this.remindShow = false;
    },
    openLiveAndVideo(_list) {
      // 播放视频或是跳转直播
      if (this.requestData.type == "done") {
        this.showVideo = true;
        this.videoTitle = _list.title;
        this.playerOptions.sources = [
          {
            withCredentials: false,
            type: "application/x-mpegURL",
            src: _list.record_uri,
          },
        ];
      } else {
        if (_list.teacher_id != 0) {
          this.joinLiving = {
            userUuid: this.$store.state.live_id,
            userName: this.$store.state.name,
            roomUuid: _list.res_id,
            roomName: _list.title,
            duration: parseFloat(_list.max_duration) * 3600,
            id: _list.id,
            roleType: 2,
          };

          if (localStorage.getItem("livtips") == 2) {
            this.join();
          } else {
            this.remindShow = true;
          }
        }
      }
    },
    hideModals() {
      // 关闭视频弹窗
      this.showVideo = false;
      this.$refs.videoPlayer.player.pause(); // 暂停
    },
    onPlayerReadied() {
      if (!this.initialized) {
        this.initialized = true;
        this.currentTech = this.player.techName_;
      }
    },
    onTimeupdate(e) {
      // console.log('currentTime', e.cache_.currentTime)
    },
    prevClick(page) {
      console.log("上一页", page);
      this.requestData.page = page;
      this.liveList();
    },
    nextClick(page) {
      this.requestData.page = page;
      this.liveList();
    },
    /*    pageClick (page) {
      this.requestData.page = page
      this.liveList()
    }, */
    /*    pageJumpe (page) {
      this.requestData.page = page
      this.liveList()
    }, */
    prevQuickClick(page) {
      this.requestData.page = page;
      this.liveList();
    },
    nextQuickClick(page) {
      this.requestData.page = page;
      this.liveList();
    },
    currentChange(page, old) {
      console.log("分页切换", page, "切换前分页", old);
      if (page > this.total) {
        page = this.total;
      }
      this.requestData.page = page;
      this.liveList();
    },
    timeType(_list, _index) {
      // 判断时间类型
      let l = _list;
      let i = _index;
      let that = this;
      if (_list.status == 1 && _list.start_time) {
        let timestamp = new Date(_list.start_time.replace(/-/g, "/")).getTime();
        let time = timestamp - Date.parse(new Date());
        if (time < 0) {
          that.timeState[_index] = {
            states: 1,
            time:
              _list.start_time.substring(11, 16) + "-" + _list.end_time.substring(11, 16),
          };
        } else if (time < 86400000 && time > 0) {
          setTimeout(function () {
            let timestamp = new Date(_list.start_time.replace(/-/g, "/")).getTime();
            let time = timestamp - Date.parse(new Date());
            let hrs, mins, secs;
            let hr = parseInt((time / 1000 / 60 / 60) % 24);
            let min = parseInt((time / 1000 / 60) % 60);
            let sec = parseInt((time / 1000) % 60);
            hrs = hr > 9 ? hr : "0" + hr;
            mins = min > 9 ? min : "0" + min;
            secs = sec > 9 ? sec : "0" + sec;
            that.timeState[_index].time = hrs + ":" + mins + ":" + secs;
            that.timeState[_index].states = 2;
            if (time <= 0) {
              _list.status = 2;
            }
            that.timeType(l, i);
          }, 1000);
        } else if (time > 86400000) {
          console.log(that.timeState[_index]);
          that.timeState[_index] = {
            states: 3,
            time:
              _list.start_time.substring(11, 16) + "-" + _list.end_time.substring(11, 16),
          };
        }
      } else if (_list.status == 2 && _list.start_time) {
        setTimeout(function () {
          let timestamp = new Date(_list.updated_at.replace(/-/g, "/")).getTime();
          let time = Date.parse(new Date()) - timestamp;
          let hrs, mins, secs;
          let hr = parseInt((time / 1000 / 60 / 60) % 24);
          let min = parseInt((time / 1000 / 60) % 60);
          let sec = parseInt((time / 1000) % 60);
          hrs = hr > 9 ? hr : "0" + hr;
          mins = min > 9 ? min : "0" + min;
          secs = sec > 9 ? sec : "0" + sec;
          that.timeState[_index].time = hrs + ":" + mins + ":" + secs;
          that.timeState[_index].states = 2;
          that.timeType(l, i);
        }, 1000);
      } else if (_list.status == 3 && _list.start_time) {
        let timestamp = new Date(_list.start_time.replace(/-/g, "/")).getTime();
        let time = timestamp - that.nowTime;
        if (time < 0) {
          that.timeState[_index] = {
            states: 1,
            time:
              _list.start_time.substring(11, 16) + "-" + _list.end_time.substring(11, 16),
          };
        }
      } else {
        that.timeState[_index] = {
          states: 4,
          time: "暂未设置时间",
        };
        console.log(that.timeState[_index]);
      }
    },
    liveList() {
      // 我的直播课
      this.requestData.type = this.stateTYype;
      web_show(this.requestData)
        .then((response) => {
          this.liveAll = response.data.data;
          this.total = parseInt(response.data.last_page);
          this.allPage = response.data.total;
          this.liveAll.map((list, index) => {
            this.timeType(list, index);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    switchStateTap(_num) {
      // 切换完成状态
      this.stateTYype = _num;
      this.requestData.page = 1;
      this.liveList();
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.no-list {
  margin-top: 8rem;
  img {
    width: 5.48rem;
    height: 4.2rem;
    display: block;
    margin: 2rem auto;
  }
}
.liveView {
  min-width: 50rem;
  min-height: 25rem;
}
.vjs-custom-skin {
  width: 100%;
  height: 100%;
}
.dragbox {
  cursor: move;
}
.container {
  width: 100%;
  height: 100%;
  .content-live {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 2.5rem;
    .list {
      width: 48%;
      height: 11.88rem;
      background: #ffffff;
      box-shadow: 0rem 0rem 1rem #eeeeee;
      opacity: 1;
      border-radius: 1rem;
      margin-bottom: 1.88rem;
      .list-content {
        padding: 1.2rem 1rem;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        user-select: none;
        .lc-left {
          img {
            width: 5.25rem;
            height: 6.88rem;
            object-fit: cover;
          }
        }
        .lc-right {
          width: calc(100% - 6.25rem);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          text-align: left;
          .lc-title {
            font-size: 1rem;
            font-weight: bold;
            color: #363636;
          }
          .lc-teacher,
          .lc-time {
            font-size: 0.88rem;
            color: #b4b4b4;
            margin-top: 0.5rem;
          }
          .lc-time {
            span {
              color: #fd9800;
            }
            .time-start {
              color: #2cd575;
            }
          }
        }
      }
      .list-top {
        width: 100%;
        height: 2.5rem;
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        justify-content: space-between;
        padding: 0 1rem;
        align-items: center;
        div {
          img {
            display: inline-block;
          }
          &:nth-child(2) {
            font-size: 0.75rem;
          }
        }
        .overseas-study {
          color: #75b6e1;
        }
        .ielts {
          color: #fd9800;
        }
        span {
          font-size: 0.81rem;
          color: #888888;
        }
        img {
          width: 1.3rem;
          height: 1.3rem;
          margin-right: 0.63rem;
        }
      }
    }
  }
  .wait-status {
    width: 100%;
    text-align: left;
    margin-top: 1.45rem;
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.1875rem;
    color: #fd9800;
    .wait-heng {
      width: 100%;
      border-bottom: 2px solid #fd9800;
      height: 14px;
    }
    .wait-heng .caret-up-fill {
      width: 2.7rem;
      margin-right: 1.875rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter/component/live_list.vue